<div [class]="containerClass" class="theme-selector">
  <!-- Modo select -->
  @if (variant === 'select') {
    <p-select
      (onChange)="onThemeChange($event)"
      [(ngModel)]="selectedTheme"
      [options]="themeOptions"
      [placeholder]="placeholder | translate"
      [showClear]="false"
      [styleClass]="'w-full ' + dropdownClass"
      optionLabel="label"
      optionValue="value"
      >
      <ng-template let-option pTemplate="item">
        <div class="flex items-center gap-2">
          <i [class]="option.icon"></i>
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
      <ng-template let-selectedOption pTemplate="selectedItem">
        @if (selectedOption) {
          <div class="flex items-center gap-2">
            <i [class]="selectedOption.icon"></i>
            <span>{{ selectedOption.label }}</span>
          </div>
        }
      </ng-template>
    </p-select>
  }

  <!-- Modo toggle button -->
  @if (variant === 'toggle') {
    <p-button
      (onClick)="toggleTheme()"
      [icon]="getCurrentIcon()"
      [label]="showLabel ? getCurrentLabel() : ''"
      [outlined]="true"
      [size]="size"
      [styleClass]="buttonClass"
      severity="secondary"
      />
  }
</div>
